import facebook from '@assets/icons/facebook.svg';
import instagram from '@assets/icons/instagram.svg';
import youtube from '@assets/icons/youtube.svg';
import twitter from '@assets/icons/twitter.svg';
import tiktok from '@assets/icons/tiktok.svg';
import { TEXT_COLOURS, BRANDED_COLOURS, OREGON_COLOURS, GRADIENTS, SPIKES_COLOURS, WA_TRANSPARANT } from '@constants';

export const ULTIMATE_MAX_SOCIAL_LINKS = 5;
export const CLASSIC_MAX_SOCIAL_LINKS = 8;
export const ICONS = {
  facebook,
  instagram,
  youtube,
  twitter,
  tiktok,
};

export const SITES = [
  { label: 'Facebook', value: 'https://facebook.com/' },
  { label: 'Instagram', value: 'https://instagram.com/' },
  { label: 'Youtube', value: 'https://youtube.com/' },
  { label: 'Twitter', value: 'https://twitter.com/' },
  { label: 'Tik tok', value: 'https://tiktok.com/@' },
];

export const ADD_LINK_FIELD = {
  SITE: {
    name: 'site',
    options: SITES,
    selectOptions: { placeholder: '- Choose a site -' },
    rules: [{ required: true, message: 'Site is required' }],
  },
  USERNAME: {
    name: 'username',
    placeholder: 'Enter your username',
    rules: [{ required: true, message: 'Username is required' }],
  },
};

export const FORM_FIELD = {
  LINKS: {
    name: 'links',
    label: 'Current links',
    rules: [{ min: 1, max: CLASSIC_MAX_SOCIAL_LINKS }],
  },
  TITLE: {
    name: 'title',
    label: 'Title (optional):',
  },
  COLOR: {
    name: 'colour',
    label: 'Colour:',
    colors: [GRADIENTS['gradient-2'].key],
  },
  BACKGROUND_COLOR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [...BRANDED_COLOURS, ...OREGON_COLOURS, ...TEXT_COLOURS, ...SPIKES_COLOURS, GRADIENTS['gradient-1'].key],
  },
};

export const INITIAL_VALUES = {
  [FORM_FIELD.LINKS.name]: [],
  [FORM_FIELD.BACKGROUND_COLOR.name]: FORM_FIELD.BACKGROUND_COLOR.colors[0],
};
